<template>
  <b-container>
    <b-card>
      <h3>Not found!</h3>
      <b-button to="home" class="btn-round" variant="primary">
        <i class="bi-caret-left"></i>
        Back
      </b-button>
    </b-card>
  </b-container>
</template>

<script>
export default {
  name: 'NotFound',
  props: {
    msg: String
  }
}
</script>

<style scoped></style>
